"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewProductSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("../ProductInfo/styles");
var _styles2 = require("../SearchPreviewProduct/styles");
var _constants = require("./constants");
var _styles3 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreviewProductSkeleton = ({
  animation,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    className: className,
    isClickable: false,
    "data-testid": getTestId(_constants.PRODUCT_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.ImageSkeleton, {
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.Info, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.UnifiedSkeleton, {
            variant: "text",
            height: 15,
            width: 60,
            animation: animation
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.UnifiedSkeleton, {
            variant: "text",
            height: 19,
            width: "40%",
            animation: animation
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.UnifiedSkeleton, {
            variant: "text",
            height: 19,
            width: 35,
            animation: animation
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.PriceAndButton, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.Price, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.UnifiedSkeleton, {
            variant: "text",
            height: 19,
            width: 40,
            animation: animation
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.ButtonSkeleton, {
          variant: "circular",
          animation: animation
        })]
      })]
    })]
  });
};
exports.SearchPreviewProductSkeleton = SearchPreviewProductSkeleton;
